import { Form } from './components/Form';
import { StripeWrapper } from './components/StripeWrapper';
import { TProps } from './types/TProps';

export const PaymentForm = (props: TProps) => {
  return (
    <StripeWrapper>
      <Form {...props} />
    </StripeWrapper>
  );
};
